import React from 'react';

export interface FootNoteProps_t {
    id: string;
    // gets the reference number
    f: (id: string) => number;
}

function getFootNoteRefId(id: string): string {
    return `${id}-footNoteRef`;
}

function getFootNoteId(id: string): string {
    return `${id}-footNote`;
}

function makeScrollTo(id: string): (e: React.MouseEvent) => void {
    return (e) => {
        e.preventDefault();
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "auto" });
    }
}

export const Footnote: React.FC<FootNoteProps_t> = (props) => {
    return (<sup id={getFootNoteId(props.id)}>
        <a href={`#${getFootNoteRefId(props.id)}`}
            onClick={makeScrollTo(getFootNoteRefId(props.id))}
        >
            {props.f(props.id)}
        </a>
    </sup>);
};

export interface FootNoteRefProps_t {
    id: string;
    text?: string;
    ref: string;
}

export const FootnoteRef: React.FC<FootNoteRefProps_t & { number: number }> = (props) => {
    return (
  <sup>
    <div
      id={getFootNoteRefId(props.id)}
      style={{ display: "flex", alignItems: "flex-start", gap: "4px" }}
    >
      <span>{props.number}</span>

      <button
        className="back-arrow-btn"
        title="Back to text"
        onClick={makeScrollTo(getFootNoteId(props.id))}
        style={{ margin: "2px" }}
      >
        <span className="back-arrow">↩</span>
      </button>

      <div style={{ flex: 1 }}>
        {props.text}
        <a style={{ margin: "2px" }} href={props.ref}>
          {props.ref}
        </a>
      </div>
    </div>
  </sup>
);
};
